var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"e-card"},[_c('div',{staticClass:"e-card__container"},[_c('b-tabs',{ref:"bTabs",attrs:{"nav-wrapper-class":"e-card__header","nav-class":"e-card__nav-tabs","content-class":"e-card__nav-item"}},[_vm._t("default")],2),_vm._v(" "),(_vm.controls)?_c('e-card-header',{ref:"tHeader",on:{"move":_vm.handleMove}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c1dcf272","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/card/card.vue
// module id = 3ssj
// module chunks = 22